import type { AuditDetails, Entity } from '../entity';
import { WebhookEventName } from '../webhooks-v2/webhook.entity.type';

/** A definition belongs to its tenant database; it is independent of the OAuth runtime identity. */
export interface AgentDefinition extends Entity, AuditDetails {
    name: string;
    contextKey: ExtensionAgentContextKey;
    instructions: string;
    enabled: boolean;
    triggers: ExtensionAgentTrigger[];
    revision: number;
}

export enum ExtensionAgentContextKey {
    Job = 'job',
}

export enum ExtensionAgentTrigger {
    Created = 'created',
    Updated = 'updated',
    StatusChanged = 'status_changed',
}

export const EXTENSION_AGENT_TRIGGER_EVENTS: Record<ExtensionAgentTrigger, string> = {
    [ExtensionAgentTrigger.Created]: WebhookEventName.JobCreated,
    [ExtensionAgentTrigger.Updated]: WebhookEventName.JobUpdated,
    [ExtensionAgentTrigger.StatusChanged]: WebhookEventName.JobStatusChanged,
};

export interface SaveAgentDefinitionRequest {
    _id: string;
    name: string;
    contextKey: ExtensionAgentContextKey;
    instructions: string;
    enabled: boolean;
    triggers: ExtensionAgentTrigger[];
    revision?: number;
}

export interface GetAgentDefinitionsRequest {
    search?: string;
    contextKey?: ExtensionAgentContextKey;
    page?: number;
    pageSize?: number;
}

export interface AgentDefinitionsPage {
    items: AgentDefinition[];
    total: number;
    page: number;
    pageSize: number;
}

export enum ExtensionAgentSocketSubject {
    Capabilities = 'GetExtensionAgentCapabilitiesQuery',
    List = 'GetExtensionAgentsQuery',
    Get = 'GetExtensionAgentQuery',
    Save = 'SaveExtensionAgentCommand',
    Delete = 'DeleteExtensionAgentCommand',
    Assignments = 'GetExtensionAgentAssignmentsQuery',
    SetAssignment = 'SetExtensionAgentAssignmentCommand',
    RunNow = 'RunExtensionAgentNowCommand',
}
